// extracted by mini-css-extract-plugin
export default {"root":"E16ldbmLRI","root_leftAligned":"iLJhRyASxc","root_centerAligned":"ibJATSTYto","root_rightAligned":"hCS0qav4Lh"};